import React from 'react';
import { Helmet } from 'react-helmet';
import { Mail, Phone, Github, Linkedin, ArrowUpRight } from 'lucide-react';
import '../styles/Home.css';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Nikhil Savita | Full-Stack Developer & AI Enthusiast</title>
        <meta name="description" content="I'm Nikhil Savita, a full-stack developer and AI enthusiast based in Goa." />
      </Helmet>

      <div className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <p className="hero-label">Full-Stack Developer & AI Enthusiast</p>
            <h1 className="hero-title">
              Nikhil<br />Savita
            </h1>
            <p className="hero-description">
              Computer Science student at Padre Conceicao College of Engineering
              with a passion for building innovative web and AI solutions.
              Strong problem-solving skills with keen interest in backend
              development and cloud computing.
            </p>
            <p className="hero-location">Based in Majorda, Goa</p>

            <div className="hero-buttons">
              <a href="/resume/Nikhil_Savita_Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn-primary">
                View Resume <ArrowUpRight size={14} />
              </a>
              <a href="mailto:nikhilsavita186@gmail.com" className="btn-secondary">
                Get in Touch
              </a>
            </div>

            <div className="hero-socials">
              <a href="mailto:nikhilsavita186@gmail.com" aria-label="Email"><Mail size={18} /></a>
              <a href="tel:+918149745684" aria-label="Phone"><Phone size={18} /></a>
              <a href="https://github.com/Nikhil181511" target="_blank" rel="noreferrer" aria-label="GitHub"><Github size={18} /></a>
              <a href="https://www.linkedin.com/in/nikhilsavita186" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={18} /></a>
            </div>
          </div>

          <div className="hero-image">
            <img src="/pro.jpg" alt="Nikhil Savita" className="profile-img" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
